import { Auth } from "aws-amplify"
import React, { Component } from "react"
import { connect } from "react-redux"
import FetchSpinner from "../../global/FetchSpinner/FetchSpinner"
import SiteWrapper from "../../structure/SiteWrapper/SiteWrapper"
import FormAdditional from "./FormAdditional"
import FormAddress from "./FormAddress"
import FormContact from "./FormContact"
import FormDetails from "./FormDetails"
import FormFAQ from "./FormFAQ"
import FormHeader from "./FormHeader"
import FormImageTags from "./FormImageTags"
import FormImages from "./FormImages"
import FormPricing from "./FormPricing"
import FormReview from "./FormReview"
import FormSocial from "./FormSocial"
import FormTestimonials from "./FormTestimonials"
import FormThanks from "./FormThanks"
import * as styles from "./SupplierSignupForm.module.scss"
import fetchLambda from "@data/fetchLambda"
import lambdas from "@data/lambdas"
import { companySizeOptions } from "@data/static"
import { formStageOptions } from "@data/static"
import { priceOptions } from "@data/static"
import * as actions from "@store/actions"
import Button from "@components/objects/Button/Button"
import Spinner from "@components/objects/Spinner/Spinner"

const {
  GET_SUPPLIER_FORM_SUBMISSION,
  SUPPLIER_SUBMIT,
  SUPPLIER_SUBMIT_FINAL,
  COGNITO_REQUEST,
  TAG_PHOTOS,
  DATO_REQUEST,
} = lambdas[process.env.NEXT_PUBLIC_ENV]
const NEXT_PUBLIC_SUPPLIER_ITEM_ID = process.env.NEXT_PUBLIC_SUPPLIER_ITEM_ID
const NEXT_PUBLIC_SUPPLIER_FAQ_DATO_ID = process.env.NEXT_PUBLIC_SUPPLIER_FAQ_DATO_ID
const NEXT_PUBLIC_SUPPLIER_TESTIMONIAL_DATO_ID = process.env.NEXT_PUBLIC_SUPPLIER_TESTIMONIAL_DATO_ID
const NEXT_PUBLIC_SUPPLIER_PHOTOS_DATO_ID = process.env.NEXT_PUBLIC_SUPPLIER_PHOTOS_DATO_ID

//react select style overide
const reactSelectStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? `0 0 0 1px #ccc` : 0,
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#fd78de",
    ":hover": {
      backgroundColor: "#fd78de",
      color: "white",
    },
  }),
}

class SupplierSignupForm extends Component {
  state = {
    itemId: null,
    termsAndConditions: false,
    step: null,
    sectionSubmitting: false,
    disableSubmit: false,
    photos: {},
    showCurrentimages: false,
    data: {
      itemType: NEXT_PUBLIC_SUPPLIER_ITEM_ID,
      name: null,
      address: null,
      addresscoordinates: null,
      addressstreet1: null,
      addressstreet2: null,
      addresscity: null,
      addresscountry: null,
      addresspostcode: null,
      suppliercountry: null,
      suppliercounty: null,
      supplierregion: null,
      primarysuppliercounty: null,
      pricesstartingfrom: null,
      dayrate: null,
      pricerange: null,
      offer: null,
      offerother: null,
      contactname: null,
      email: null,
      linkedin: null,
      twitter: null,
      facebook: null,
      instagram: null,
      pinterest: null,
      youtube: null,
      phone: null,
      website: null,
      suppliercategory: [],
      supplierservices: [],
      supplierfeature: [],
      suppliersubservices: [],
      supplierstyle: [],
      serviceareadescription: null,
      access: null,
      latelicense: null,
      seatedcapacity: null,
      standingcapacity: null,
      howlonginthebusiness: null,
      publicliabilityinsurance: null,
      vatregistered: null,
      worksAbroad: null,
      howmanypeopleinthecompany: null,
      description: null,
      internalnote: null,
      sustainability: null,
      faqs: [],
      testimonials: [],
      coverphoto: null,
      photos: [],
      reference: null,
      bundle: false,
      customSection: [],
      coverVideo: null,
      stripeId: "",
      stripeStatus: "",
      stripeTrialEnd: "",
    },
  }

  featureOptions = []
  subServiceOptions = []

  nextSectionButtonLabel = "Submit section and proceed to next"
  modularDataTypeIds = {
    faqs: NEXT_PUBLIC_SUPPLIER_FAQ_DATO_ID,
    testimonials: NEXT_PUBLIC_SUPPLIER_TESTIMONIAL_DATO_ID,
    photos: NEXT_PUBLIC_SUPPLIER_PHOTOS_DATO_ID,
  }

  componentDidMount = async () => {
    // NOTE!! The following three Auth calls seem redundant but at the moment it's the only way to make sure the session data is refreshed correctly in the Local Storage
    await Auth.currentAuthenticatedUser({
      bypassCache: true,
    })
    await Auth.currentUserInfo()
    const session = await Auth.currentSession()
    const sessionData = session.idToken.payload

    if (sessionData) {
      this.setState({
        userStatus: sessionData["custom:status"],
      })

      //check that supplier has itemid before trying to get old data
      if (sessionData["custom:itemId"] && sessionData["custom:itemId"].length) {
        const response = await fetchLambda(
          GET_SUPPLIER_FORM_SUBMISSION,
          {
            sessionToken: session.getIdToken().getJwtToken(),
          },
          () => {
            alert("Unable to get supplier info, please refresh the page and try again")
          }
        )
        if (response) {
          await this.refreshData(response)

          if (this.props.supplierDashboard) {
            this.setState({
              highestStep: formStageOptions[formStageOptions.length - 2],
            })
            this.updateStep(this.props.step)
          } else {
            let loadedStep
            if (!response.data.formStage && response.data.step) {
              // if old structure

              const formstagepos = response.data.step >= 5 ? response.data.step - 2 : response.data.step - 1
              loadedStep = formStageOptions[formstagepos]

              //update formstage in cognito
            } else {
              loadedStep = response.data.formStage
            }
            this.setState({
              highestStep: loadedStep,
            })
            this.updateStep(loadedStep)
          }
        }
      } else {
        this.setState({
          step: formStageOptions[0],
          highestStep: formStageOptions[0],
        })
      }
    }
  }

  updateHighestStep = async () => {
    if (this.props.supplierDashboard) {
      return
    }

    const currentHighestPos = this.state.highestStep ? formStageOptions.indexOf(this.state.highestStep) : 0
    const nextStepPos = formStageOptions.indexOf(this.state.step) + 1
    const newHighestPos = Math.max(currentHighestPos, nextStepPos)

    if (newHighestPos > currentHighestPos) {
      const newHighestStep = formStageOptions[newHighestPos]
      const user = await Auth.currentAuthenticatedUser()
      const currentSession = await Auth.currentSession()
      const session = currentSession.getIdToken().getJwtToken()

      await fetchLambda(COGNITO_REQUEST, {
        session: session,
        username: user.username,
        action: "update",
        attributes: [{ Name: "custom:formStage", Value: newHighestStep }],
      })

      this.setState({
        highestStep: newHighestStep,
      })
    }
  }

  updateStep = (step = null) => {
    if (this.props.supplierDashboard) {
      this.setState((prevState) => ({
        step: step ? step : prevState.step,
      }))
    } else {
      this.setState((prevState) => ({
        step: step ? step : formStageOptions[formStageOptions.indexOf(prevState.step) + 1],
      }))
    }

    window.scrollTo(0, 0)
  }

  createSubservices = (services, subservices) => {
    const { serviceOptions, subServiceOptions } = this.props.staticData

    services.forEach((service) => {
      const serviceData = serviceOptions.filter((serviceOption) => serviceOption.value === service)
      const subServiceOptionsData = subServiceOptions.filter((item) => service.includes(item.dataService.id))

      const subserviceData = subServiceOptionsData.filter((el) => el.value === subservices.find((e) => e === el.value))

      this.setState({
        data: {
          ...this.state.data,
          ["suppliersubservices[" + serviceData[0].value + "]"]: subserviceData.map((el) => el.value),
        },
      })
    })
  }

  formatPhotoData = (results = {}, upload) => {
    if (upload) {
      const imgFormatQuery = "?auto=compress&fit=crop&fm=jpg&w=600&h=500"

      const { serviceTagOptions, styleOptions, categoryOptions, settingOptions, supplierOptions } =
        this.props.staticData

      let newCustomData = {
        category: "",
        service: "",
        style: "",
        setting: "",
        suppliers: "",
      }

      if (upload.defaultFieldMetadata.en.customData) {
        for (const [key, value] of Object.entries(upload.defaultFieldMetadata.en.customData)) {
          switch (key) {
            case "category":
              newCustomData[key] = categoryOptions.find((option) => option.value === value)
              break
            case "service":
              newCustomData[key] = serviceTagOptions.find((option) => option.value === value)
              break
            case "style":
              newCustomData[key] = styleOptions.find((option) => option.value === value)
              break
            case "setting":
              newCustomData[key] = settingOptions.find((option) => option.value === value)
              break
            case "othersuppliers":
              if (value) {
                const othersuppliers = JSON.parse(value)
                if (othersuppliers && othersuppliers.length) {
                  if (isNaN(othersuppliers[0])) {
                    newCustomData[key] = othersuppliers.map((supplier) => ({
                      ...supplier,
                      value: supplier.id,
                      label: supplier.name,
                    }))
                  } else {
                    newCustomData[key] = supplierOptions.filter((supplierOption) =>
                      othersuppliers.find((supplier) => supplierOption.value === supplier)
                    )
                  }
                }
              }
              break
            default:
              break
          }
        }
      }

      results[upload.id] = {
        customData: newCustomData,
        url: `${upload.url + imgFormatQuery}`,
        id: upload.id,
        creator: upload.creator,
        tags: upload.tags,
        author: upload.author,
      }
    }
    return results
  }

  addDatoImageUrls = async (data) => {
    let newPhotos = {}
    const session = await Auth.currentSession()
    if (data.coverphoto && data.coverphoto.uploadId) {
      const coverphotoId = data.coverphoto.uploadId
      const coverUpload = await fetchLambda(DATO_REQUEST, {
        session: session.getIdToken().getJwtToken(),
        action: "getUpload",
        itemId: coverphotoId,
      })

      newPhotos = this.formatPhotoData(newPhotos, coverUpload.data.result)
    }

    if (data.photos && data.photos.length) {
      const photoIds = data.photos?.map((el) => el.attributes.photo?.uploadId)
      for (const photoId of photoIds) {
        if (photoId) {
          const photoUpload = await fetchLambda(DATO_REQUEST, {
            session: session.getIdToken().getJwtToken(),
            action: "getUpload",
            itemId: photoId,
          })
          newPhotos = this.formatPhotoData(newPhotos, photoUpload.data.result)
        }
      }
    }

    return newPhotos
  }

  //Refresh the data after each step
  refreshData = async (response) => {
    const newData = response.data.result

    let data = { ...this.state.data }
    Object.keys(newData).forEach((key) => {
      const matches = key.match(/\[(.*?)\]/)
      if (key === "id" || (matches && matches.length)) {
        return
      }

      if (key === "suppliersubservices") {
        this.createSubservices(newData.supplierservices, newData.suppliersubservices)
        return
      }

      data = { ...data, [key]: newData[key] }
    })

    let photos = {}
    if ((newData.coverphoto && newData.coverphoto.uploadId) || (newData.photos && newData.photos.length)) {
      photos = await this.addDatoImageUrls(data)
    }

    this.setState({
      data: data,
      itemId: newData.id,
      photos: photos,
      showCurrentimages: !!Object.values(photos).length,
    })

    return
  }

  //Standard input fields
  handleChange = (event, meta = false) => {
    let target = event.target
    let value
    let name

    value = target.type === "checkbox" ? target.checked : target.value
    name = target.name
    if (meta) {
      this.setState({
        [name]: value,
      })
    } else {
      this.setState({
        data: { ...this.state.data, [name]: value },
      })
    }
  }

  handleAddressUpdate = (addressFields) => {
    this.setState({
      data: { ...this.state.data, ...addressFields },
    })
  }

  //Terms and Conditions checkbox, enable/disable Submit button as checked/unchecked
  validate = () => {
    return this.state.termsAndConditions && this.wordCount(this.state.data.description) <= this.descriptionMaxWordCount
  }

  disableSubmit = (isDisable = true) => {
    this.setState({
      disableSubmit: isDisable,
    })
  }

  //photos
  handleChangePhotos = (selected, type, photoId) => {
    let newPhotos = { ...this.state.photos }
    newPhotos[photoId].customData[type.name] = selected
    //reset service on category update
    if (type.name === "category") {
      newPhotos[photoId].customData.service = null
    }
    this.setState({
      photos: newPhotos,
    })
  }

  //Multiselect input
  handleChangeSelect = (selected, type) => {
    let value
    let name

    if (Array.isArray(selected)) {
      value = selected.map((selected) => selected.value)
      name = type.name
    } else {
      value = selected ? selected.value : []
      name = type.name
    }

    this.setState({
      data: { ...this.state.data, [name]: value },
    })

    if (name === "supplierstyle") {
      this.setState({ styleMaxReached: value.length === 3 })
    }

    if (name === "suppliercategory") {
      this.setState({ categoryMaxReached: value.length === 5 })
    }

    if (name === "supplierservices") {
      this.setState({ serviceMaxReached: value.length === 1 })
    }

    if (name === "primarysuppliercounty") {
      this.setState({ primaryCountyMaxReached: value.length === 5 })
    }

    if (name.startsWith("suppliersubservices")) {
      const matches = name.match(/\[(.*?)\]/)
      const serviceId = matches[1]
      let subServiceMaxReached = {}

      if (this.state.subServiceMaxReached) {
        subServiceMaxReached = { ...this.state.subServiceMaxReached }
      }

      subServiceMaxReached[serviceId] = value.length === 5
      this.setState({ subServiceMaxReached: subServiceMaxReached })
    }
  }

  //Dynamic input fields
  handleChangeDynamic = (event, name) => {
    let target = event.target
    let value

    //Create an empty object if not initialized
    if (this.state.data[name] === null) {
      value = []
    } else {
      //Else copy and modify the old one
      value = [...this.state.data[name]]
    }

    //If there is nothing at the index yet, add a new entry
    if (value[target.dataset.id]) {
      value[target.dataset.id].attributes[target.className] = target.value
    } else {
      //Else edit the existing one
      //TODO LOW There might be a way to standardize this object and unify it to the image upload one
      value[target.dataset.id] = {
        type: "item",
        attributes: {
          [target.className]: target.value,
        },
        relationships: {
          item_type: {
            data: {
              type: "item_type",
              id: this.modularDataTypeIds[name],
            },
          },
        },
      }
    }

    this.setState({
      data: { ...this.state.data, [name]: value },
    })
  }

  // video change
  handleChangeVideo = async (event) => {
    const target = event.target
    const value = target.value
    const name = target.name
    let video
    if (value.includes("youtu")) {
      const rx = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
      const providerUidMatch = value.match(rx)
      const providerUid = providerUidMatch?.length > 1 ? providerUidMatch[1] : ""
      video = {
        height: 344,
        provider: "youtube",
        providerUid: providerUid,
        thumbnailUrl: `https://i.ytimg.com/vi/${providerUid}/hqdefault.jpg`,
        title: "Title",
        url: value,
        width: 459,
      }
    } else if (value.includes("vimeo")) {
      const vimeoRequestURL = `https://vimeo.com/api/oembed.json?url=${value}`
      const result = await fetch(vimeoRequestURL)
      if (result.ok) {
        const metaData = await result.json()
        video = {
          height: metaData.height,
          provider: "vimeo",
          providerUid: metaData.video_id,
          thumbnailUrl: metaData.thumbnail_url,
          title: metaData.title,
          url: value,
          width: metaData.width,
        }
      } else {
        video = {
          height: "",
          provider: "vimeo",
          providerUid: "",
          thumbnailUrl: "",
          title: "",
          url: value,
          width: "",
        }
      }
    } else {
      video = null
    }

    this.setState({
      data: {
        ...this.state.data,
        [name]: video,
      },
    })
  }

  //File uploader input fields
  handleChangeFile = (fileIds, name) => {
    if (Array.isArray(fileIds)) {
      if (fileIds.length) {
        let files = []

        fileIds.forEach((fileId, index) => {
          files[index] = {
            type: "item",
            attributes: {
              photo: {
                uploadId: fileId.toString(),
                alt: null,
                title: null,
                customData: {},
              },
            },
            relationships: {
              item_type: {
                data: {
                  type: "item_type",
                  id: this.modularDataTypeIds[name],
                },
              },
            },
          }
        })

        this.setState({
          data: { ...this.state.data, [name]: files },
        })
      } else {
        this.setState({
          data: { ...this.state.data, [name]: [] },
        })
      }
    } else if (fileIds) {
      this.setState({
        data: {
          ...this.state.data,
          [name]: {
            uploadId: fileIds.toString(),
            alt: null,
            title: null,
            customData: {},
          },
        },
      })
    }
  }

  //File uploader input fields
  handleChangeCheckboxArray = (event, selected, name) => {
    let target = event.target
    let checked = target.checked
    let value

    if (checked) {
      //Create an empty array if not initialized
      if (!this.state.data[name]) {
        value = []
      } else {
        //Else copy and modify the old one
        value = [...this.state.data[name]]
      }

      value.push(selected)
    } else {
      value = [...this.state.data[name]]
      let index = value.indexOf(selected)
      if (index !== -1) value.splice(index, 1)
    }

    this.setState({
      data: { ...this.state.data, [name]: value },
    })
  }

  //Submit form
  handleSubmit = async (event) => {
    event.preventDefault()

    this.setState({
      disableSubmit: true,
      sectionSubmitting: true,
    })

    let response

    if (this.state.step === "Tags") {
      response = await this.savePhotoTags()
    } else if (this.state.step === "Review") {
      response = await this.finalSubmit()
    } else {
      response = await this.saveSupplierData()
      if (response) {
        this.refreshData(response)
      }
    }

    if (response.ok) {
      await this.updateHighestStep()
      this.updateStep()
    }

    this.setState({
      sectionSubmitting: false,
      showCurrentimages: !!Object.values(this.state.photos).length,
    })
  }

  savePhotoTags = async () => {
    const { serviceOptions } = this.props.staticData
    const user = await Auth.currentSession()
    const photos = Object.values(this.state.photos)
    const serviceId = this.state.data.supplierservices?.[0]
    const service = serviceOptions.find((serviceOption) => serviceOption.value === serviceId)
    let i,
      j,
      chunkCount = 5
    let response
    for (i = 0, j = photos.length; i < j; i += chunkCount) {
      const chunk = photos.slice(i, i + chunkCount)
      response = await fetchLambda(TAG_PHOTOS, {
        sessionToken: user.getIdToken().getJwtToken(),
        photos: chunk,
        supplier: {
          id: this.state.itemId,
          name: this.state.data.name,
          slug: this.state.data.slug,
          service: service && service.label ? service.label : "",
        },
      })
    }
    return response
  }

  finalSubmit = async () => {
    const user = await Auth.currentSession()
    const response = await fetchLambda(SUPPLIER_SUBMIT_FINAL, {
      sessionToken: user.getIdToken().getJwtToken(),
      itemId: this.state.itemId,
      data: this.state.data,
      supplierDashboard: !!this.props.supplierDashboard,
    })
    return response
  }
  saveSupplierData = async () => {
    const user = await Auth.currentSession()
    const response = await fetchLambda(SUPPLIER_SUBMIT, {
      sessionToken: user.getIdToken().getJwtToken(),
      // step: this.state.step,
      itemId: this.state.itemId,
      data: this.state.data,
      supplierDashboard: !!this.props.supplierDashboard,
    })
    return response
  }

  render() {
    const {
      styleMaxReached,
      categoryMaxReached,
      serviceMaxReached,
      subServiceMaxReached,
      primaryCountyMaxReached,
      data,
      photos,
    } = this.state

    const {
      categoryOptions,
      countyOptions,
      serviceOptions,
      subServiceOptions,
      styleOptions,
      settingOptions,
      supplierOptions,
    } = this.props.staticData

    return (
      <div className={styles.SupplierSignupForm}>
        <FormHeader
          updateStep={this.updateStep}
          title={this.props.header ? "Supplier Signup" : ""}
          step={this.state.step}
          highestStep={
            this.props.supplierDashboard ? formStageOptions[formStageOptions.length - 2] : this.state.highestStep
          }
          supplierDashboard={this.props.supplierDashboard}
        />

        <div className={styles.inner}>
          <SiteWrapper className={styles.form}>
            <Spinner active={this.state.sectionSubmitting} message="Saving, please do not close or refresh the page" />
            <form onSubmit={this.handleSubmit}>
              {(() => {
                switch (this.state.step) {
                  case "Contact":
                    return <FormContact data={data} handleChange={this.handleChange} />
                  case "Address":
                    return <FormAddress data={data} handleAddressUpdate={this.handleAddressUpdate} />

                  case "Details":
                    return (
                      <FormDetails
                        data={data}
                        reactSelectStyles={reactSelectStyles}
                        handleChange={this.handleChange}
                        handleChangeSelect={this.handleChangeSelect}
                        styleOptions={styleOptions}
                        handleChangeCheckboxArray={this.handleChangeCheckboxArray}
                        styleMaxReached={styleMaxReached}
                        categoryMaxReached={categoryMaxReached}
                        serviceMaxReached={serviceMaxReached}
                        categoryOptions={categoryOptions}
                        serviceOptions={serviceOptions}
                        subServiceOptions={subServiceOptions}
                        subServiceMaxReached={subServiceMaxReached}
                      />
                    )

                  case "Pricing":
                    return (
                      <FormPricing
                        data={data}
                        reactSelectStyles={reactSelectStyles}
                        handleChange={this.handleChange}
                        handleChangeSelect={this.handleChangeSelect}
                        priceOptions={priceOptions}
                      />
                    )

                  case "Social":
                    return <FormSocial data={data} handleChange={this.handleChange} />

                  case "Additional":
                    return (
                      <FormAdditional
                        data={data}
                        reactSelectStyles={reactSelectStyles}
                        handleChange={this.handleChange}
                        handleChangeSelect={this.handleChangeSelect}
                        companySizeOptions={companySizeOptions}
                      />
                    )

                  case "FAQ":
                    return <FormFAQ data={data} handleChangeDynamic={this.handleChangeDynamic} />

                  case "Testimonials":
                    return <FormTestimonials data={data} handleChangeDynamic={this.handleChangeDynamic} />

                  case "Images":
                    return (
                      <FormImages
                        data={data}
                        photos={photos}
                        handleChangeVideo={this.handleChangeVideo}
                        handleChangeFile={this.handleChangeFile}
                        disableSubmit={this.disableSubmit}
                        setShowCurrentimages={(showCurrentimages) =>
                          this.setState({
                            showCurrentimages: showCurrentimages,
                          })
                        }
                        showCurrentimages={this.state.showCurrentimages}
                      />
                    )

                  case "Tags":
                    return (
                      <FormImageTags
                        reactSelectStyles={reactSelectStyles}
                        photos={photos}
                        categoryOptions={categoryOptions}
                        settingOptions={settingOptions}
                        handleChangePhotos={this.handleChangePhotos}
                        styleOptions={styleOptions}
                        supplierOptions={supplierOptions}
                      />
                    )

                  case "Review":
                    return (
                      <FormReview
                        photos={photos}
                        data={data}
                        handleChange={this.handleChange}
                        sectionSubmitting={this.state.sectionSubmitting}
                      />
                    )

                  case "Thanks":
                    return <FormThanks data={data} />

                  default:
                    return <FetchSpinner />
                }
              })()}
              {this.state.step && formStageOptions.indexOf(this.state.step) < 10 && (
                <div className={styles.sectionSubmit}>
                  <Button
                    text={this.props.supplierDashboard ? "Save & Update" : "Save & Continue"}
                    type="submit"
                    onEnable={this.state.sectionSubmitting}
                    disabled={this.state.step === "Images" && this.state.disableSubmit}
                  />
                </div>
              )}
            </form>
          </SiteWrapper>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    staticData: state.staticData.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authCheck: () => dispatch(actions.authCheck()),
    login: (email, password) => dispatch(actions.login(email, password)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSignupForm)
